import type { MouseEvent } from "react";

type MobileListChevronProps = {
    id?: string;
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    "aria-label"?: string;
};

export function MobileListChevron({
    id,
    onClick,
    className,
    "aria-label": ariaLabel = "View details",
}: MobileListChevronProps) {
    return (
        <button
            type="button"
            id={id}
            className={["gs-mobile-list-chevron", className].filter(Boolean).join(" ")}
            onClick={onClick}
            aria-label={ariaLabel}
        >
            <em className="icon ni ni-chevron-right" aria-hidden />
        </button>
    );
}
